import { TournamentBracketMatchGameStatus } from '@okletsplay/core';
import { uniqBy } from 'lodash';
import { MatchGameResultFormField } from 'modules/bracket/interfaces';
import { addMethod, object } from 'yup';

addMethod(object, 'uniqueMatchGameScore', function (propertyName, message) {
  return this.test('uniqueMatchGameScore', function (value) {
    const runningMatchGameIndex =
      this.parent.find(
        (matchGame: MatchGameResultFormField) =>
          Number(matchGame.status) === TournamentBracketMatchGameStatus.Running
      )?.matchGameIndex ?? -1;

    const editableGamesCount = Math.floor(this.parent.length / 2);
    const editableResultIndexes: number[] = [];
    this.parent.forEach((result: MatchGameResultFormField) => {
      const status = Number(result.status);
      if (status === TournamentBracketMatchGameStatus.Running) {
        editableResultIndexes.push(result.matchGameIndex);
      }

      if (
        editableGamesCount >= runningMatchGameIndex &&
        status === TournamentBracketMatchGameStatus.Completed
      ) {
        editableResultIndexes.push(result.matchGameIndex);
      }
    });

    if (!editableResultIndexes.includes(value.matchGameIndex)) {
      return true;
    }

    // Draw match game result is equal 0.5 score.
    const uniqueScore: MatchGameResultFormField[] = uniqBy(this.parent, propertyName);
    if (uniqueScore.length === 1 && uniqueScore?.[0]?.score === 0.5) {
      return true;
    }

    if (uniqueScore.length > 1) {
      const drawScore = uniqueScore.filter((result) => result.score === 0.5);
      if (drawScore.length) {
        throw this.createError({
          path: `${this.path}.${propertyName}`,
          message: 'A draw is only allowed for both players',
        });
      }
    }

    if (uniqueScore.length !== this.parent?.length) {
      throw this.createError({
        path: `${this.path}.${propertyName}`,
        message: message,
      });
    }

    return true;
  });
});
